module.exports = __webpack_public_path__ + "static/media/search-pizza.1eaa51f4.png";